import { render, staticRenderFns } from "./SalesFilter.vue?vue&type=template&id=6419801d"
import script from "./SalesFilter.vue?vue&type=script&lang=ts"
export * from "./SalesFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports